import { toast } from 'react-toastify';

/**
 * A change that can be taken back (a food removed from the tracker, a food changed in the diet plan): the app's toast
 * with the message and "Desfazer" at the card's end, in green ink (the toast's one action). Its look is .mt-toast__row
 * in redesign.css, beside the toasts'. Returns the toast's id.
 */
export const showUndoToast = (message, { undoLabel, onUndo, autoClose = 6000 }) =>
  toast.success(
    ({ closeToast }) => (
      <span className="mt-toast__row">
        {message}
        <button
          type="button"
          className="mt-toast__undo"
          onClick={() => {
            closeToast?.();
            onUndo();
          }}
        >
          {undoLabel}
        </button>
      </span>
    ),
    { autoClose }
  );
